<template>
  <div
    role="region"
    :aria-label="passwordSet ? 'Password Changed Confirmation' : 'Email Sent'"
  >
    <portal to="authTitle" v-if="passwordSet">
      <h2
        class="mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl"
      >
        Password was changed successfully
      </h2>
    </portal>
    <portal to="authTitle" v-else>
      <h2
        class="mt-6 text-xl leading-tight text-center sm:text-2xl md:text-3xl"
      >
        Check your email inbox
      </h2>
      <p class="text-gray-600">We just sent a link to {{ email }}</p>
    </portal>
    <div class="mt-6">
      <button
        class="block w-full text-center rounded font-semibold border-2 border-transparent px-4 min-h-10 bg-yellow-500 text-gray-700 hover:bg-yellow-900 focus:bg-yellow-900"
        @click="redirectLogin()"
        type="button"
      >
        Got it {{ passwordSet ? ", let me login" : "" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      default: "email",
      required: true
    },
    passwordSet: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    redirectLogin() {
      this.$router.push("/sign-in");
    }
  }
};
</script>
